import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/Observable';
import { UserGioLocation } from '../../../models/user/usergioLocation';
import { Ng2DeviceService } from 'ng2-device-detector';
import { utilityService } from '../utility.service';
import { AppSettings } from '../../_common/constants/app.constants';
import { geolocation } from '../../../sharedcomponents/commonservice/geolocation/geoloc';
@Injectable()
export class userlogoutservice {
  constructor(private utilserv: utilityService, private deviceService: Ng2DeviceService, private geoloc: geolocation) {}
  public logout() {
    return this.utilserv.soapPostwithoutAction(this.prepareEnvelopeLogoff(), AppSettings.loginService);
  }
  private prepareEnvelopeLogoff() {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                        <s:Header>
                          <a:Action s:mustUnderstand="1">http://LoginSoapService/IMicroServiceLogin/Logout</a:Action>
                          <a:MessageID>urn:uuid:39ffd2fa-08af-49c1-90bd-1e4e519c6853</a:MessageID>
                          <a:ReplyTo>
                            <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                          </a:ReplyTo>
                        </s:Header>
                        <s:Body>
                          <LogoutRequest xmlns="http://LoginSoapService/">
                            <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                              <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                              <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                              <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                              <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                              <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                              <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                              <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                              <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                              <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
                              <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
                              <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                            </DeviceDetails>
                            <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                            <SessionObject xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common.MicroService" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                            <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                            <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                            </SessionObject>
                          </LogoutRequest>
                        </s:Body>
                      </s:Envelope>`;

    return envelope;
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/commonservice/logout/userlogout.service.ts